import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AssignMemberSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t(
        'common:pages.organization_overview.assign_members_to_device.success',
      )}
    />
  );
};

export default AssignMemberSuccess;
